export default "__VITE_ASSET__e95636f4__"